import AuthRoute from 'components/authRoute/AuthRoute';
import AgencyModal from 'components/modals/agency-modal/agency-modal';
import { AssignAgencyModal } from 'components/modals/assign-agency-modal/assign-agency-modal';
import { AssignDivisionsModal } from 'components/modals/assign-divisions-modal/assign-divisions-modal';
import { AssignPeopleModal } from 'components/modals/assign-people-modal/assign-people-modal';
import { ConfigReportModal } from 'components/modals/config-report-modal/config-report-modal';
import { DivisionModal } from 'components/modals/division-modal/division-modal';
import { PeopleModal } from 'components/modals/people-modal/people-modal';
import { PolicyModal } from 'components/modals/policy-modal/policy-modal';
import { UserModal } from 'components/modals/user-modal/user-modal';
import DivisionsPage from 'components/pages/division-page/divisions-page';
import HomePage from 'components/pages/home-page/home-page';
import { LoginPage } from 'components/pages/login-page/login-page';
import { LogoutPage } from 'components/pages/logout-page/logout-page';
import { PeoplePage } from 'components/pages/people-page/people-page';
import { ProfilePage } from 'components/pages/profile-page/profile-page';
import FullReportPage from 'components/pages/reports/full-report-page/full-report-page';
import { ReportsPage } from 'components/pages/reports/reports-page/reports-page';
import { ShortReportPage } from 'components/pages/reports/short-report-page/short-report-page';
import UsersPage from 'components/pages/users-page/users-page';
import YearSelectionPage from 'components/pages/year-selection-page/year-selection-page';
import { PrivateRoute } from 'components/private-route/private-route';
import { PermissionsProvider } from 'contexts';
import { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router';
import { navigation } from 'shared/utils/navigation';
import { useAppDispatch, useAppSelector } from 'store';
import { checkIsLogged } from 'store/authentication/authentication.slice';
import { closeMenu } from 'store/menu/menu.slice';

import Agencies from '../../pages/agencies-page/agencies-page';
import Policies from '../../pages/policies-page/policies-page';
import Priorities from '../../pages/priorities-page/priorities-page';
import ResetPassword from '../../pages/reset-password-page/reset-password-page';
import UpdatePassword from '../../pages/update-password-page/update-password-page';
import { LeftMenu } from '../left-menu/left-menu';
import TopBar from '../top-bar/top-bar';

function NavigationSetter() {
  navigation.navigate = useNavigate();
  return null;
}

export const PageLayout = () => {
  const dispatch = useAppDispatch();
  const loggedIn = useAppSelector((state) => state.authentication.loggedIn);
  const menu = useAppSelector((state) => state.menu);

  const hideMenu = () => {
    dispatch(closeMenu());
  };

  useEffect(() => {
    dispatch(checkIsLogged());
  }, [dispatch]);

  return (
    <div className={'page'}>
      <BrowserRouter>
        <NavigationSetter />
        <PermissionsProvider>
          {loggedIn && <TopBar />}
          {loggedIn && (
            <LeftMenu
              isOpen={menu.isOpen}
              bgClick={hideMenu}
              hideMenu={hideMenu}
            />
          )}
          <Routes>
            <Route
              path="/login"
              element={
                <AuthRoute>
                  <LoginPage />
                </AuthRoute>
              }
            />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/update-password/:token"
              element={<UpdatePassword />}
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <HomePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/policy-areas"
              element={
                <PrivateRoute>
                  <Policies />
                </PrivateRoute>
              }
            />
            <Route
              path="/priorities"
              element={
                <PrivateRoute>
                  <Priorities />
                </PrivateRoute>
              }
            />
            <Route
              path="/people"
              element={
                <PrivateRoute>
                  <PeoplePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <ProfilePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/agencies"
              element={
                <PrivateRoute>
                  <Agencies />
                </PrivateRoute>
              }
            />
            <Route
              path="/divisions"
              element={
                <PrivateRoute>
                  <DivisionsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <PrivateRoute>
                  <ReportsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports/full-report"
              element={
                <PrivateRoute>
                  <FullReportPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports/short-report"
              element={
                <PrivateRoute>
                  <ShortReportPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/years"
              element={
                <PrivateRoute>
                  <YearSelectionPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute>
                  <UsersPage />
                </PrivateRoute>
              }
            />
            <Route path="*" element={<LoginPage />} />
          </Routes>
          {loggedIn && <PolicyModal />}
          {loggedIn && <AssignAgencyModal />}
          {loggedIn && <AgencyModal />}
          {loggedIn && <AssignDivisionsModal />}
          {loggedIn && <DivisionModal />}
          {loggedIn && <AssignPeopleModal />}
          {loggedIn && <PeopleModal />}
          {loggedIn && <UserModal />}
          {loggedIn && <ConfigReportModal />}
        </PermissionsProvider>
      </BrowserRouter>
    </div>
  );
};
